<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-table :data="items" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column class="key" field="key" label="Key">{{props.row.key|toWords}}</b-table-column>
          <b-table-column field="text" label="Value">
            <template v-if="props.row.displayType === 'list'">
              <ul>
                <li
                  v-for="(itemVal, itemIndex) in props.row.value"
                  :key="`${props.row.key}-${itemIndex}`"
                >{{matchListItem(itemVal, props.row.key)}}</li>
              </ul>
            </template>
            <template v-else-if="props.row.displayType === 'date'">{{props.row.value|shortDatetime}}</template>
            <template v-else-if="props.row.widget === 'checkbox'">{{props.row.value|yesNo}}</template>
            <template v-else-if="props.row.displayType === 'key_value_list'">
              <ul>
                <li
                  v-for="(rowItem, itemIndex) in props.row.value"
                  :key="`${props.row.key}-${itemIndex}`"
                >{{translateValue(rowItem, props.row)}}</li>
              </ul>
            </template>
            <template v-else>{{props.row.value|smartTruncate}}</template>
          </b-table-column>
          <b-table-column field="format" label="Type">{{props.row.type|typeLabel}}</b-table-column>
          <b-table-column field="_id" label="Edit">
            <span class="edit" v-on:click="showSetting(props.row.key)">
              <b-icon icon="square-edit-outline" />
            </span>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <SettingDetail v-if="showDetail" :setting="setting" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getSettings } from "../api/methods";
import { mapSetting, matchKeyValueOptions } from "../api/mappers";
import { extractNestedOptions } from "../api/helpers";
import filters from "../mixins/filters";
import SettingDetail from "./SettingDetail";
import { bus } from "../main";

export default {
  name: "SettingList",
  components: {
    SettingDetail
  },
  mixins: [filters],
  data() {
    return {
      items: [],
      num: 0,
      total: 0,
      perPage: 100,
      start: 0,
      showDetail: false,
      currKey: "",
      setting: {
        type: Object,
        default: {
          _id: "",
          key: "",
          type: "",
          value: null,
          createdAt: null,
          modifiedAt: null
        }
      }
    };
  },
  computed: {
    ...mapGetters(["settings", "options"]),
    wrapperClasses() {
      let cls = ["settings"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    numItems() {
      return this.items.length;
    }
  },
  created() {
    bus.$on("escape", val => {
      if (val) {
        this.close();
      }
    });
  },
  mounted() {
    if (this.$route.path) {
      const parts = this.$route.path.substring(1).split("/");
      if (parts.length > 1) {
        this.currKey = parts[1];
      }
    }
    this.mapSetting();
    setTimeout(() => {
      this.mapSetting();
    }, 500);
  },
  filters: {
    typeLabel(val) {
      switch (val) {
        case "array_string":
          return "Text list";
        case "array_integer":
          return "Integer list";
        case "key_value_array":
          return "Key / value list";
      }
      return val;
    },
    smartTruncate(val) {
      let str = val;
      if (typeof val === "string") {
        if (val.length > 21) {
          const firstSpace = val.trim().indexOf(" ");
          if (firstSpace < 0 || firstSpace > 16) {
            str = val.substring(0, 20) + "...";
          }
        }
      }
      return str;
    }
  },
  methods: {
    mapSetting(remap) {
      if (
        (this.items.length < 1 || remap === true) &&
        this.settings instanceof Object
      ) {
        if (remap !== true) {
          getSettings().then(data => {
            if (data.items instanceof Array) {
              this.items = data.items.map(mapSetting);
              if (this.currKey.length > 3) {
                this.showSetting(this.currKey);
              }
            }
          });
        }
      }
    },
    remapSetting() {
      this.mapSetting(true);
    },
    showSetting(key) {
      const setting = this.items.find(s => s.key === key);
      if (setting instanceof Object) {
        if (setting.key) {
          this.setting = setting;
          const newPath = "/settings/" + key;
          if (this.$route.path !== newPath) {
            this.$router.push(newPath);
          }
          this.showDetail = true;
        }
      }
    },
    close(data) {
      this.showDetail = false;
      const newPath = this.$route.path
        .substring(1)
        .split("/")
        .shift();
      if (this.$route.path !== newPath) {
        this.$router.push(newPath);
      }
      if (data instanceof Object) {
        if (data._id) {
          const si = this.items.findIndex(item => item._id === data._id);
          if (si >= 0) {
            this.items[si].value = data.value;
          }
        }
      }
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      return cls.join(" ");
    },
    matchListItem(itemVal, key) {
      let v = itemVal.replace(/_+/, " ");
      let opts = [];
      switch (key) {
        case "enabled_art_media":
          opts = extractNestedOptions("work", "medium", this.options);
          break;
        case "enabled_graduate_statuses":
          opts = extractNestedOptions(
            "submission",
            "graduateStatus",
            this.options
          );
          break;
      }
      if (opts.length > 0) {
        let opt = opts.find(o => o.key === itemVal);
        if (opt) {
          v = opt.value;
        }
      }

      return v;
    },
    extractKeyValOption(item, setting) {
      const opts = matchKeyValueOptions(setting.key);
      let str = "";
      if (opts instanceof Array &&  opts.length > 0) {
        const opt = opts.find(opt => opt.key === item.value);
        if (opt instanceof Object) {
          str = item.key + ": " + opt.label;
        }
      }
      return str;
    },
    translateValue(item, setting) {
      let str = item.value;
      switch (setting.type) {
        case "key_value_array":
          str = this.extractKeyValOption(item, setting);
          break;
      }
      return str;
    }
  }
};
</script>